import { applyPortalBodyClass, portalBodyClass } from "~/utils/portalBodyClass";

/** SSR + client: set portal body classes via useHead and sync DOM early on the client. */
export default defineNuxtPlugin({
  enforce: "pre",
  setup() {
    const router = useRouter();

    if (import.meta.client) {
      applyPortalBodyClass(window.location.pathname);
    }

    useHead({
      bodyAttrs: {
        class: computed(() => portalBodyClass(router.currentRoute.value.path)),
      },
    });

    if (import.meta.client) {
      router.afterEach((to) => {
        applyPortalBodyClass(to.path);
      });
    }
  },
});
